module.exports = __webpack_public_path__ + "videos/timelapse-video-asuka.534db1a.mp4";